import React from 'react'
import { motion } from 'framer-motion'

export default function Loading() {
    return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0}}
                transition={{ duration: 0.5 }} className="flex items-center justify-center w-full h-dvh md:h-screen max-w-full text-white bg-gradient-to-br from-black/95 to-black relative">
                <div
                    className="flex flex-col items-center">
                    <h1 className="box-progress text-6xl md:text-8xl" data-text="Hakim Hizmi.">
                        Hakim Hizmi.
                    </h1>
                    <h3 className="box-progress1 text-xl md:text-3xl italic" data-text="Full stack Developer">
                        Full stack Developer
                    </h3>
                </div>
            </motion.div>
    )
}
